
<!-- Mobile Overlay -->
@if (isOpen()) {
  <div (click)="onLinkClick()" class="fixed inset-0 bg-black/60 z-30 lg:hidden"></div>
}

<!-- Sidebar -->
<div [class]="'fixed inset-y-0 left-0 z-40 flex flex-col w-64 bg-white shadow-lg transition-transform duration-300 ease-in-out lg:relative lg:translate-x-0 ' + (isOpen() ? 'translate-x-0' : '-translate-x-full')">
  <div class="flex items-center justify-between h-16 px-4 bg-white shadow-sm flex-shrink-0">
    <span class="text-gray-800 font-bold uppercase">{{ 'backOffice.sidebar.title' | translate }}</span>
    <button (click)="onLinkClick()" class="lg:hidden text-gray-500 hover:text-gray-800">
      <i class="fa-solid fa-times text-xl"></i>
    </button>
  </div>
  <div class="flex flex-col flex-1 overflow-y-auto">
    <nav class="flex-1 px-2 py-4 bg-white space-y-1">
      
      <!-- Special Super Admin Link -->
      @if(isPlatformAdmin()) {
          <a routerLink="/platform"
             routerLinkActive="bg-purple-100 text-purple-700"
             [routerLinkActiveOptions]="{ exact: false }"
             (click)="onLinkClick()"
             class="flex items-center px-4 py-3 text-gray-800 rounded-md hover:bg-purple-50 mb-4 border-2 border-purple-200 bg-purple-50 shadow-sm group">
            <i class="fa-solid fa-earth-asia text-lg w-6 text-center text-purple-600 group-hover:animate-pulse"></i>
            <span class="mx-4 font-bold">{{ 'backOffice.sidebar.platformAdmin' | translate }}</span>
          </a>
          <div class="border-b border-gray-200 mb-4 mx-4"></div>
      }

      @for(item of navItems(); track item.nameKey) {
        <a [routerLink]="item.path"
            routerLinkActive="bg-[#EAF7ED] text-[#35B44F]"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="onLinkClick()"
            class="flex items-center px-4 py-2 text-gray-700 rounded-md hover:bg-gray-200">
          <i [class]="item.icon + ' text-lg w-6 text-center'"></i>
          <span class="mx-4 font-medium">{{ item.nameKey | translate }}</span>
        </a>
      }
    </nav>
  </div>
</div>
